module.exports = __webpack_public_path__ + "img/withImage.770a3f32.jpg";